import http from '../http'

export default {
  getContacts () {
    return http.get('/contact')
  }
}
